import { createContext } from 'react';
/* eslint-disable @repo/internal/react/require-jsdoc */
export const ModalContext = /*#__PURE__*/createContext(null);
export const ScrollContext = /*#__PURE__*/createContext(null);